import { Injectable } from '@angular/core';
import { CurrentUserService } from './current-user.service';

@Injectable({
  providedIn: 'root',
})
export class RefreshTokenExpirationService {
  private readonly checkIntervalMs = 10000;
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private logoutTriggered = false;

  constructor(private currentUserService: CurrentUserService) { }

  startMonitoring(): void {
    if (this.intervalId) {
      return;
    }

    this.checkRefreshTokenExpiration();
    this.intervalId = setInterval(() => {
      this.checkRefreshTokenExpiration();
    }, this.checkIntervalMs);
  }

  private checkRefreshTokenExpiration(): void {
    const refreshToken = this.getRefreshTokenFromStorage();

    if (!refreshToken) {
      this.logoutTriggered = false;
      return;
    }

    const expirationTime = this.getTokenExpirationTime(refreshToken);
    if (!expirationTime) {
      return;
    }

    if (Date.now() >= expirationTime && !this.logoutTriggered) {
      this.logoutTriggered = true;
      this.currentUserService.logout();
    }
  }

  private getRefreshTokenFromStorage(): string | null {
    const storedAuthToken = localStorage.getItem('auth_app_token');
    if (!storedAuthToken) {
      return null;
    }

    try {
      const parsedAuthToken = JSON.parse(storedAuthToken);
      const tokenData = JSON.parse(parsedAuthToken.value);
      return tokenData?.refresh_token ?? null;
    } catch {
      return null;
    }
  }

  private getTokenExpirationTime(token: string): number | null {
    const tokenParts = token.split('.');
    if (tokenParts.length !== 3) {
      return null;
    }

    try {
      const normalizedPayload = tokenParts[1]
        .replace(/-/g, '+')
        .replace(/_/g, '/')
        .padEnd(Math.ceil(tokenParts[1].length / 4) * 4, '=');
      const payload = JSON.parse(atob(normalizedPayload));
      return payload?.exp ? Number(payload.exp) * 1000 : null;
    } catch {
      return null;
    }
  }
}
